import request from '@/utils/request'
import apiConfig from '@/api/apiconfig'

export function getSystemDictionary(data) {
  return request({
    url: `${apiConfig.AMS}/contractInfo/systemDictionary`,
    method: 'post',
    data
  })
}
// 签约主体
export function getSignName(data) {
  return request({
    url: `${apiConfig.AMS}/contractInfo/searchSign`,
    method: 'post',
    data
  })
}

export function uploadFile(data) {
  return request({
    url: `${apiConfig.AMS}/contractInfo/upload`,
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export function addRemote(data) {
  return request({
    url: `${apiConfig.AMS}/contractInfo/addRemote`,
    method: 'post',
    data
  })
}
